import { Children, isValidElement } from 'react';
function filter<T>(items: (T | null)[]): T[] {
  return items.filter((item) => item) as T[];
}
function isChildFnFactory(
  childComponent: React.FC<any> & {
    displayName?: string;
  },
) {
  return function isChildFn(node: React.ReactNode): node is React.ReactElement {
    return (
      isValidElement(node) &&
      typeof node.type === 'function' &&
      (node.type === childComponent ||
        (() => {
          const name = (node.type as any).displayName ?? node.type.name;
          return name === (childComponent.displayName ?? childComponent.name);
        })())
    );
  };
}

export function mapSpecChildrenFactory<T>(
  childComponent: React.FC<T> & {
    displayName?: string;
  },
) {
  const isItem = isChildFnFactory(childComponent);
  return <R>(
    children: React.PropsWithChildren<unknown>['children'],
    fn: (
      item: Partial<T>,
      key: React.Key | null,
      children: React.PropsWithChildren<unknown>['children'],
      index: number,
    ) => R,
  ) => {
    return children
      ? filter(
          Children.toArray(children).map((node, index) => {
            if (isValidElement(node) && isItem(node)) {
              const { key, props } = node;
              return fn((props || {}) as T, key, props?.children, index);
            }

            return null;
          }),
        )
      : [];
  };
}
